
<div class="dashboard-view">
  <ftu-block
    dismiss-key="dashboard"
    icon="space_dashboard"
    title="This is your Dashboard"
    description="The Dashboard displays a variety of high-level information about the sports card market. The graph displays the total sales volume tracked by Card Ladder per day. Below that, you'll find various helpful widgets to help you in your collecting knowledge, such as deals ending soon."
  />

  <page-header title="Dashboard">
    <template #actions>
      <icon-button
        icon="settings"
        @click="customizeModalOpen = true"
      />
    </template>
  </page-header>

  <div v-if="loaded" class="dashboard-content">
    <component
      :is="component"
      v-for="({ component }, i) in dashboardWidgets"
      :key="component"
      :data="dashboard"
      :zoom.sync="zoom"
      :scale.sync="scale"
      :bottom="i === dashboardWidgets.length - 1"
    />
  </div>

  <spinner v-else />

  <welcome-modal />

  <modal
    title="Customize Your Dashboard"
    :open="customizeModalOpen"
    @close="cancelConfigChanges"
  >
    <draggable
      v-model="widgetOptions"
      handle=".handle"
      ghost-class="ghost"
      class="draggable-container"
    >
      <align
        v-for="widget in widgetOptions"
        :key="widget.component"
        flex
        :class="{ disabled: !widget.visible }"
      >
        <align small-gap>
          <icon class="handle" name="drag_handle" />

          <span>{{ DASHBOARD_WIDGETS[widget.component].name }}</span>
        </align>

        <icon-button
          :icon="widget.visible ? 'visibility' : 'visibility_off'"
          @click="widget.visible = !widget.visible"
        />
      </align>
    </draggable>

    <div class="button-row">
      <btn @click="saveConfigChanges">
        Save
      </btn>

      <btn kind="secondary" @click="cancelConfigChanges">
        Cancel
      </btn>
    </div>
  </modal>
</div>
